const getters = {
    token: state => state.login.token || localStorage.getItem('token'),
    role: state => state.login.roleType || localStorage.getItem('roleType'),
    userId: state => state.login.userId || localStorage.getItem('userId'),
    makerId: state => state.login.makerId || localStorage.getItem('makerId'),
    token: state => state.makerlogin.token || localStorage.getItem('token'),
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews,
    messagenumber: state => state.login.messagenumber
  }
  export default getters